import cn from "../../utils/cn";
export const semanticKeys = ["default", "primary", "success", "warning", "attention", "danger", "purple", "sky", "danger-dark"];
export const variantKeys = ["default", "contained", "surface", "outlined"];
export const textVariants = {
    default: "text-gray-11",
    primary: "text-primary-11",
    success: "text-success-11",
    danger: "text-danger-11",
    warning: "text-warning-11",
    attention: "text-attention-11",
    purple: "text-accessory-purple-11",
    sky: "text-accessory-sky-11",
    "danger-dark": "text-danger-11",
};
export const textForegroundVariants = {
    default: "text-white",
    primary: "text-white",
    success: "text-white",
    danger: "text-white",
    warning: "text-white",
    attention: "text-attention-12",
    purple: "text-white",
    sky: "text-accessory-sky-12",
    "danger-dark": "text-white",
};
export const borderVariants = {
    default: "border border-gray",
    primary: "border border-primary",
    success: "border border-success",
    warning: "border border-warning",
    attention: "border border-attention",
    danger: "border border-danger",
    purple: "border border-accessory-purple",
    sky: "border border-accessory-sky",
    "danger-dark": "border border-danger-11",
};
export const backgroundSolidVariants = {
    default: "bg-gray-11",
    primary: "bg-primary",
    success: "bg-success",
    danger: "bg-danger",
    warning: "bg-warning",
    attention: "bg-attention",
    purple: "bg-accessory-purple",
    sky: "bg-accessory-sky",
    "danger-dark": "bg-danger-11",
};
export const backgroundSurfaceVariants = {
    default: "bg-gray-3",
    primary: "bg-primary-3",
    success: "bg-success-3",
    danger: "bg-danger-3",
    warning: "bg-warning-3",
    attention: "bg-attention-3",
    purple: "bg-accessory-purple-3",
    sky: "bg-accessory-sky-3",
    "danger-dark": "bg-danger-4",
};
export const positionVariants = {
    top: "top-0 inset-x-1/2 -translate-y-1/2 -translate-x-1/2",
    bottom: "bottom-0 inset-x-1/2 translate-y-1/2 -translate-x-1/2",
    left: "left-0 inset-y-1/2 -translate-x-1/2 -translate-y-1/2",
    right: "right-0 inset-y-1/2 translate-x-1/2 -translate-y-1/2",
    "top-right": "top-0 right-0 -translate-y-1/2 translate-x-1/2",
    "top-left": "top-0 left-0 -translate-y-1/2 -translate-x-1/2",
    "bottom-right": "bottom-0 right-0 translate-y-1/2 translate-x-1/2",
    "bottom-left": "bottom-0 left-0 translate-y-1/2 -translate-x-1/2",
};
export const variantVariants = {
    default: cn(backgroundSurfaceVariants.default, textVariants.default),
    contained: cn(backgroundSolidVariants.default, textVariants.default),
    surface: cn(backgroundSurfaceVariants.default, textVariants.default),
    outlined: cn(borderVariants.default, textVariants.default),
};
export const containedCompoundVariants = semanticKeys.map((key) => ({
    variant: "contained",
    color: key,
    className: cn(backgroundSolidVariants[key], textForegroundVariants[key]),
}));
export const surfaceCompoundVariants = semanticKeys.map((key) => ({
    variant: "surface",
    color: key,
    className: cn(backgroundSurfaceVariants[key], textVariants[key]),
}));
export const outlinedCompoundVariants = semanticKeys.map((key) => ({
    variant: "outlined",
    color: key,
    className: cn(borderVariants[key], textVariants[key]),
}));
export const dotCompoundVariants = semanticKeys.map((key) => ({
    variant: "dot",
    color: key,
    className: backgroundSolidVariants[key],
}));
export default {
    variantVariants,
    textVariants,
    textForegroundVariants,
    borderVariants,
    backgroundSolidVariants,
    backgroundSurfaceVariants,
    positionVariants,
    containedCompoundVariants,
    surfaceCompoundVariants,
    outlinedCompoundVariants,
};
